import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './PostDetails.css';

const PostDetail = () => {
  const { postId } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`/api/posts/${postId}`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to load post');
        }
        return response.json();
      })
      .then(data => {
        setPost(data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching post:', error);
        setError('Failed to load post');
        setLoading(false);
      });
  }, [postId]);

  if (loading) {
    return <div className="post-detail-page"><div className="post-detail-container">Loading...</div></div>;
  }

  if (error) {
    return <div className="post-detail-page"><div className="post-detail-container">{error}</div></div>;
  }

  return (
    <main className="post-detail-page">
      <article className="post-detail-container">
        <button className="back-button" onClick={() => navigate('/advice')}>Back to Advice</button>
        <div className="post-detail-header">
          <span>{post.category || 'General'}</span>
          <h1>{post.title}</h1>
          {post.createdAt && <p>Updated {new Date(post.createdAt).toLocaleDateString()}</p>}
        </div>
        {post.imageUrl && <img src={post.imageUrl} alt={post.title} className="post-detail-image" />}
        <div className="post-detail-content">
          {String(post.content || '').split('\n').filter(Boolean).map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>
      </article>
    </main>
  );
};

export default PostDetail;
